export default __webpack_public_path__ + "static/media/intrFormGuide.e58a29af.png";